import React from 'react';
import ButtonBase from './ButtonBase';
import Asset from '../Asset';
import Box from '../Box/Box';
import { TButtonThirdParty } from './types/TButtons';

const getBrandIcon = (brand: TButtonThirdParty['brand']) =>
  ({
    facebook: 'SocialBadgeFacebook',
    google: 'SocialBadgeGoogle',
    apple: 'SocialBadgeApple',
    bancontact: 'IconLogoBancontact',
    ideal: 'IconLogoIdeal',
  })[brand || ''];

const getCustomClassName = (brand) => {
  switch (brand) {
    case 'google':
    case 'bancontact':
      return 'hz-IconWithBackground ';
    default:
      return '';
  }
};

const ThirdParty = ({ as = 'button', brand, children, ...rest }: TButtonThirdParty) => (
  <ButtonBase {...rest} as={as} kind="thirdParty" brand={brand}>
    <Box as="div" name="ThirdPartyIconContainer" className={getCustomClassName(brand)}>
      <Asset.Square name={`${getBrandIcon(brand)}`} size="m" inverse={true} />
    </Box>
    <Box as="div" name="ThirdPartyTextContainer">
      {children}
    </Box>
  </ButtonBase>
);

export default ThirdParty;
